import { ContentState, convertFromHTML, EditorState } from "draft-js";
import { Form, Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Form as bootstrapForm, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import Switch from "react-switch";
import * as yup from "yup";
import { PRIVATE_ROUTES, REGEX } from "../../helper/constants";
import actions from "../../store/actions/actions";
import SingleDropDown from "../Common/singleDropDown";
import { StorageService } from "./../../services/storage.service";
import { Utils } from "./../../utils/utils";
import { CKEditorComponent } from "./../Common/CkEditor";
import { DragDrop } from "./../Common/DragDrop";
import Spinner from "./../Common/Spinner";

export const ExtraServicesForm = (props) => {
  //Todo Hotel Id Dynamic
  //const hotelId = 1
  const { t, i18n } = useTranslation();
  const formikRef = useRef();
  const { id } = useParams();
  const [tid, setTid] = useState(null);
  const history = useHistory();
  const hotelDetails = useSelector((state) => state?.hotelDetails?.result);
  const currencySymbol = hotelDetails?.currency?.symbol;
  const [fileUploaded, setFileUploaded] = useState(null);
  const [content, setContent] = useState(null);
  const [editorState, setEditorState] = useState();
  const serviceById = useSelector((state) => state.extraservices.serviceById);
  const [imageFromApi, setimageFromApi] = useState([]);
  const dispatch = useDispatch();
  const gotSuccess = useSelector((state) => state?.extraservices?.success);
  const isAdd = useSelector((state) => state?.extraservices?.isAdd);
  const isUpdate = useSelector((state) => state?.extraservices?.isUpdate);
  const storageService = new StorageService();
  const hotelId = +storageService.getItem("hotelId");
  const [language, setLanguage] = useState(null);
  const [cmsContent, setCMSContent] = useState(null);
  const isLoading = useSelector((state) => state?.network?.isLoading);
  const [allowAccess, setAllowAccess] = useState(true);
  const [DealType, setDealType] = useState([]);
  const typesAvailable = useSelector((state) => state?.extraservices?.types);

  useEffect(() => {
    const DealType = typesAvailable?.map((type) => {
      return { value: type.value, id: type.id };
    });
    setDealType(DealType);
  }, [typesAvailable]);

  useEffect(() => {
    dispatch(actions.getDealTypes());
  }, []);

  // const handleOfferChangeEvent = (e) => {
  //   setOffer(e.target.value)
  // }

  const availableLanguagesFromSelector = useSelector(
    (state) => state.constants.languages
  );

  const availableFilteredLanguages = Utils.setupLanguageRes(
    availableLanguagesFromSelector
  );

  const availableDealTypes = useSelector((state) => state.extraservices.types);

  const [formInitialValue, setFormInitialValue] = useState({
    is_active: true,
    name: "",
    // description: "",
    price: "",
    start_date: "",
    end_date: "",
    has_no_end_date: false,
    service_type: "",
  });
  const onClickCancelButton = () => {
    history.push("/deals-and-offer");
  };

  const updateEditorState = (editorState, setFieldValue) => {
    setContent(editorState);
    setEditorState(editorState);

    if (Utils.getHTMLtoPlainText(editorState).trim().length) {
      setEditorState(editorState);
    } else {
      setEditorState("");
    }
  };
  const formSchema = yup.object().shape({
    is_active: false,
    name: yup.string().trim().min(1).required("Please Enter Special offers"),
    // description: yup.string().required("Please Enter Description"),
    price: yup.number().min(0).required("Please Enter Valid Service Price"),
    start_date: yup.date().required("Please Enter Start date"),
    end_date: yup
      .date()
      .min(yup.ref("start_date"))
      .when("has_no_end_date", {
        is: false,
        then: yup.date().required("Must enter email address"),
      }),
    service_type: yup.number().required("Please Enter the field"),
    //end_date: yup.date().when("start_date", {is: value => value,then: yup.date().required().min(yup.ref("start_date"))
    // })
  });
  const AddService = (payload) => {
    dispatch(actions.addService(payload));
  };
  const updateService = (payload) => {
    dispatch(actions.updateService(id, payload));
  };

  const updateUplodedImage = () => {
    if (window.location.pathname.includes("/extra-service/edit")) {
      return true;
    } else {
      return false;
    }
  };

  useEffect(() => {
    setAllowAccess(Utils.isAccessAllowedByRoute(PRIVATE_ROUTES.deal_create));

    setLanguage(props.selectedLanguageForUpdate);
    if (props.serviceDetails && props.isForEdit) {
      const des = Utils.langValueGenerator(
        props.serviceDetails?.h_offers_and_services_ts || [],
        "body",
        props.selectedLanguageForUpdate
      );

      formikRef.current.setValues({
        is_active: props.serviceDetails.is_active,
        name: Utils.langValueGenerator(
          props.serviceDetails?.h_offers_and_services_ts || [],
          "name",
          props.selectedLanguageForUpdate
        ),
        price: props.serviceDetails?.price,
        start_date: props.serviceDetails?.start_date,
        end_date: props.serviceDetails?.has_no_end_date
          ? props.serviceDetails?.start_date
          : props.serviceDetails?.end_date,
        has_no_end_date: props.serviceDetails?.has_no_end_date,
        service_type: props.serviceDetails?.service_type || null,
      });
      const img = [];
      props.serviceDetails?.h_offers_media?.map((image, i) =>
        img.push({
          arrId: image.id,
          preview: image.image_path,
          serviceId: props.serviceDetails.id,
        })
      );

      setEditorState(des || "");
      setContent(des || "");
      setimageFromApi(img);
      setTid(
        props.serviceDetails?.h_offers_and_services_ts[
          props.selectedLanguageForUpdate - 1
        ]?.id
      );
    }
  }, [props.serviceDetails, props.selectedLanguageForUpdate]);
  useEffect(() => {
    if (props.cmsContent) {
      setContent(props.cmsContent);
    }
  }, [props.cmsContent]);
  useEffect(() => {
    if (gotSuccess && !props.isForEdit) {
      clearForm();
      const htmlConverted = convertFromHTML(`<p></p>`);
      const finalizeContent = EditorState.createWithContent(
        ContentState.createFromBlockArray(htmlConverted)
      );
      setEditorState(finalizeContent);
      setContent(finalizeContent);
    }
    if (isAdd) {
      history.push("/deals-and-offer");
    }
  }, [gotSuccess, isAdd]);

  const clearForm = () => {
    formikRef.current?.resetForm();
  };
  const hasNoEndDate = (values, errors) => {
    if (!values.end_date) {
      formikRef.current.values.has_no_end_date = false;
    }
    if (errors.end_date) {
      formikRef.current.values.end_date = values.start_date;
    }
  };

  const handleOnPriceChange = (e, setFieldValue) => {
    const re = REGEX.NEGATIVE_REGEX;
    const value = parseFloat(
      e.target.value?.replace(currencySymbol, "").replaceAll(",", "")
    );

    if (value === "" || value > 0 || re.test(value)) {
      setFieldValue("price", value === "" ? "" : +(value * 1).toString());
    } else {
      setFieldValue("price", "");
    }
  };
  return !isLoading ? (
    <React.Fragment>
      <Formik
        initialValues={{
          ...formInitialValue,
        }}
        validationSchema={formSchema}
        innerRef={formikRef}
        enableReinitialize={true}
        onSubmit={(values) => {
          setFormInitialValue(values);
          if (!props.isForEdit) {
            const payload = {
              data: {
                ...values,
                description: editorState,
                name: values.name.trim(),
                hotel_id: hotelId,
                language_id: language,
                price: values.price && values.price > 0 ? values.price : 0,
              },
              image: fileUploaded,
            };
            if (values.has_no_end_date) {
              payload.data.has_no_end_date = 1;
              payload.data.end_date = null;
            }
            AddService(payload);
          } else {
            const payload = {
              data: {
                ...values,
                description: editorState,
                name: values.name.trim(),
                language_id: language,
                tid: tid,
                image_deleted: fileUploaded?.length > 0 ? false : true,
              },
              image: fileUploaded,
            };
            if (values.has_no_end_date) {
              payload.data.has_no_end_date = 1;
              payload.data.end_date = null;
            }
            updateService(payload);
          }
        }}
      >
        {({
          handleChange,
          errors,
          values,
          touched,
          setFieldValue,
          submitForm,
        }) => (
          <>
            {!isLoading ? (
              <Form>
                <Row
                  className="mt-3 sub-header-text"
                  style={{ fontSize: "13px" }}
                >
                  <label style={{ fontSize: "13px" }}>
                    {t(
                      "Modules.Deals and Offers (+ add new deal).Activate deal?"
                    )}
                  </label>
                  <div>
                    <span className="switch-lable">
                      {t("Modules.Deals and Offers (+ add new deal).Off")}
                    </span>
                    <Switch
                      onChange={(value) => {
                        setFieldValue("is_active", value);
                      }}
                      checked={values?.is_active}
                      name="is_active"
                    />
                    <span className="switch-lable">
                      {t("Modules.Deals and Offers (+ add new deal).On")}
                    </span>
                  </div>
                </Row>
                <Row className="mt-3">
                  <Col md={6}>
                    <bootstrapForm.Group>
                      <bootstrapForm.Label className={"sub-header-text"}>
                        {t(
                          "Modules.Deals and Offers (+ add new deal).Deal name"
                        )}
                        <span style={{ color: "red" }}>*</span>
                      </bootstrapForm.Label>
                      <bootstrapForm.Control
                        type="text"
                        name="name"
                        isInvalid={touched?.name && errors?.name}
                        onChange={handleChange}
                        value={values?.name.trimStart()}
                      ></bootstrapForm.Control>
                    </bootstrapForm.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <div
                      className="sub-header-text description-header mb-2 form-label"
                      style={{ fontSize: "13px" }}
                    >
                      {t(
                        "Modules.Deals and Offers (+ add new deal).Deal description"
                      )}
                    </div>
                    {/* <TextEditor
                  name="description"
                  editorState={editorState}
                  errors={errors}
                  setFieldValue={setFieldValue}
                  setEditorState={(updateContent) => {
                    updateEditorState(updateContent, setFieldValue);
                  }}
                /> */}

                    <CKEditorComponent
                      name="description"
                      errors={errors}
                      editorState={editorState}
                      setFieldValue={setFieldValue}
                      newContent={content}
                      setEditorState={(updateContent) => {
                        updateEditorState(updateContent, setFieldValue);
                      }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <div className="description-header mt-2 mb-2 sub-header-text">
                      {t(
                        "Modules.Deals and Offers (+ add new deal).Add a picture to your deal"
                      )}
                    </div>

                    <DragDrop
                      maximumFile={1}
                      multiUpload={false}
                      handleChange={setFileUploaded}
                      values={imageFromApi}
                      // path={
                      //   props.isForEdit && imageFromApi.length > 0
                      //     ? "update"
                      //     : "add"
                      // }
                      path={updateUplodedImage() ? "update" : "add"}
                    ></DragDrop>
                    <div>
                      <div style={{ fontSize: "small" }}>
                        {t("Common Translations.Picture Validation")}
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <bootstrapForm.Group>
                      <bootstrapForm.Label className="mt-2 sub-header-text">
                        types
                        <span style={{ color: "red" }}>*</span>
                      </bootstrapForm.Label>
                      <SingleDropDown
                        val={availableDealTypes || []}
                        inpName={"service_type"}
                        updateDropdown={setFieldValue}
                        touched={touched}
                        errors={errors}
                        values={values}
                      ></SingleDropDown>
                    </bootstrapForm.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <bootstrapForm.Group>
                      <bootstrapForm.Label className="mt-2 sub-header-text">
                        {t(
                          "Modules.Deals and Offers (+ add new deal).Deal price"
                        )}{" "}
                        {currencySymbol && <>({currencySymbol})</>}
                        <span style={{ color: "red" }}>*</span>
                      </bootstrapForm.Label>
                      {Utils.NumberFormat(
                        currencySymbol,
                        `extra-service-price`,
                        values?.price,
                        "",
                        false,
                        touched?.price && errors?.price,
                        "price",
                        (e) => handleOnPriceChange(e, setFieldValue),
                        bootstrapForm.Control
                      )}
                    </bootstrapForm.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={3}>
                    <bootstrapForm.Group>
                      <bootstrapForm.Label className={"sub-header-text"}>
                        {t(
                          "Modules.Deals and Offers (+ add new deal).Deal start date"
                        )}
                        <span style={{ color: "red" }}>*</span>
                      </bootstrapForm.Label>
                      <bootstrapForm.Control
                        type="date"
                        name="start_date"
                        isInvalid={touched?.start_date && errors?.start_date}
                        onChange={handleChange}
                        value={values?.start_date}
                      ></bootstrapForm.Control>
                    </bootstrapForm.Group>
                  </Col>
                  {!values.has_no_end_date && (
                    <Col md={3}>
                      <bootstrapForm.Group>
                        <bootstrapForm.Label className={"sub-header-text"}>
                          {t(
                            "Modules.Deals and Offers (+ add new deal).Deal end date"
                          )}
                          <span style={{ color: "red" }}>*</span>
                        </bootstrapForm.Label>
                        <bootstrapForm.Control
                          type="date"
                          name="end_date"
                          isInvalid={touched?.end_date && errors?.end_date}
                          onChange={handleChange}
                          value={values?.end_date}
                          min={values?.start_date}
                        ></bootstrapForm.Control>
                      </bootstrapForm.Group>
                    </Col>
                  )}
                </Row>
                <Row>
                  <Col md={9}>
                    <bootstrapForm.Group>
                      <bootstrapForm.Check
                        name="has_no_end_date"
                        className={"sub-header-text"}
                        label={t(
                          "Modules.Deals and Offers (+ add new deal).No end date - checkbox"
                        )}
                        onChange={(value) => {
                          setFieldValue(
                            "has_no_end_date",
                            !values.has_no_end_date
                          );
                          if (!values.has_no_end_date) {
                            setFieldValue("end_date", values.start_date);
                          } else {
                            setFieldValue("end_date", null);
                          }
                        }}
                        value={values?.has_no_end_date}
                        checked={values.has_no_end_date}
                      />
                    </bootstrapForm.Group>
                  </Col>
                </Row>
                <hr className="border-line" />
                <Row className="mt-3">
                  {!props.isForEdit ? (
                    <Col md={2} sm={6} xs={6}>
                      {allowAccess ? (
                        <Button
                          variant="primary"
                          disabled={
                            props.selectedLanguageForUpdate !== props.baseLangId
                          }
                          onClick={() => {
                            submitForm();
                          }}
                        >
                          {" "}
                          {t(
                            "Modules.Deals and Offers (+ add new deal).+ Add new deal"
                          )}
                        </Button>
                      ) : (
                        <></>
                      )}
                    </Col>
                  ) : (
                    <Col md={2} sm={6} xs={6}>
                      {allowAccess ? (
                        <Button
                          variant="primary"
                          disabled={
                            props.selectedLanguageForUpdate !== props.baseLangId
                          }
                          onClick={() => {
                            hasNoEndDate(values, errors);

                            submitForm();
                          }}
                        >
                          {t(
                            "Modules.Deals and Offers (edit offer).Save button"
                          )}
                        </Button>
                      ) : (
                        <></>
                      )}
                    </Col>
                  )}
                  <Col md={2} sm={6} xs={6}>
                    <Button variant="secondary" onClick={onClickCancelButton}>
                      {t(
                        "Modules.Deals and Offers (+ add new deal).Cancel button"
                      )}
                    </Button>
                  </Col>
                </Row>
              </Form>
            ) : (
              <Spinner />
            )}
          </>
        )}
      </Formik>
    </React.Fragment>
  ) : (
    <Spinner />
  );
};
